import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faIdCard,
  faCreditCard,
  faFileSignature,
  faCamera,
  faCircleQuestion,
} from '@fortawesome/free-solid-svg-icons';
import './MobileCustomerFlowHeaderStepper.css';

const STEP_ICONS = {
  ValidaStep: faIdCard,
  PaymentStep: faCreditCard,
  ConfirmationStep: faFileSignature,
  DocumentUploadStep: faCamera,
};

const STEP_ACCESS_LABELS = {
  ValidaStep: 'Validá tu identidad',
  PaymentStep: 'Pagá',
  ConfirmationStep: 'Confirmá tu compra',
  DocumentUploadStep: 'Subí documentos',
};

function stepIconFor(stepName) {
  return STEP_ICONS[stepName] ?? faCircleQuestion;
}

/**
 * Compact icon-only progress for mobile header (completed / active / pending).
 */
const MobileCustomerFlowHeaderStepper = ({
  flowStepNames,
  stepStatuses,
  currentStepIndex,
}) => {
  if (!flowStepNames?.length) {
    return null;
  }

  return (
    <nav
      className="mobile-customer-flow-header-stepper"
      aria-label="Progreso de tu compra"
    >
      <ol className="mobile-customer-flow-header-stepper-list">
        {flowStepNames.map((stepName, index) => {
          const apiStatus = stepStatuses?.[stepName];
          const done =
            apiStatus === 'completed' || apiStatus === 'processed';
          const isCurrentFlowStep =
            index === currentStepIndex &&
            currentStepIndex < flowStepNames.length;
          const active = !done && isCurrentFlowStep;

          let stateClass = 'mobile-customer-flow-header-stepper-item--pending';
          if (done) {
            stateClass = 'mobile-customer-flow-header-stepper-item--completed';
          } else if (active) {
            stateClass = 'mobile-customer-flow-header-stepper-item--active';
          }

          const icon = done ? faCheck : stepIconFor(stepName);
          const accessLabel =
            STEP_ACCESS_LABELS[stepName] ?? `Paso ${index + 1}`;

          return (
            <li
              key={stepName}
              className={`mobile-customer-flow-header-stepper-item ${stateClass}`}
            >
              <span
                className="mobile-customer-flow-header-stepper-circle"
                aria-current={active ? 'step' : undefined}
                aria-label={
                  done
                    ? `${accessLabel}, completado`
                    : active
                      ? `${accessLabel}, paso actual`
                      : `${accessLabel}, pendiente`
                }
              >
                <FontAwesomeIcon icon={icon} aria-hidden />
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default MobileCustomerFlowHeaderStepper;
